import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button, Row, Col, Table } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import {getAdditionalCategories, getAdditionalSubCategories, getAdditionalSubSubCategories, getBookingCategories,getBookingSubCategories,getBookingSubSubCategories,getTicketInfoByPlaceId, getTicketSubSubType, getTicketSubType, getTicketType,} from "../../redux/actions/indexActions";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
const GroupBooking = ({ addFormType, placeId }) => {
    const dispatch = useDispatch();
    const { auth } = useSelector((state) => state.AuthReducer);
    // const { indexReducer: { additionalCategories ,additionalSubCategories,additionalSubSubCategories,ticketFormAdditionalFields} } = useSelector((state) => state);
    const { indexReducer: { ticketFormAdditionalFields ,TicketTypeList, TicketSubTypeList ,TicketSubSubTypeList} } = useSelector((state) => state);
    const [errors, setErrors] = useState({});
    const [addFields, setAddFields] = useState({
        booking_category_id:"",
        booking_sub_category_id:"",
        booking_sub_sub_category_id:"",
        field_name:"",
        field_type:"",
        file:"",
        link:"",
        name_attr:"",
        add_field_for:addFormType,
        active_on_main_form: "",
        is_upload_doc: 0,
        place_id:placeId,
    });
    const [ticketForm, setTicketForm] = useState({
        form_type:'',
        additionalFieldsEnabled:0,
        additionalField: 0,
        subAdditionalField: 0,
        subSubAdditionalField: 0,
        additionalFieldType: "",
        additional_field_id: "",
        sub_additional_field_id: "",
        is_additional_document: 0,
        booking_category_id: "",
        booking_sub_category_id: "",
        booking_sub_sub_category_id: "",
        is_group_booking_document: 0,
        is_additional_fields: 0,
        add_field_type:"",
        add_field_name: "",
        groupBookingEnabled: 0,
        is_group_booking_category: 0,
        is_group_booking_sub_category: 0,
        is_group_booking_sub_sub_category: 0,
        place_id: placeId,
    });
    const [ticketTypes, setTicketTypes] = useState({
        ticket_type_id:"",
        ticket_sub_type_id:"",
        ticket_sub_sub_type_id:"",
    });
    useEffect(()=>{
        // dispatch(getBookingCategories(auth.token,placeId));
        dispatch(getAdditionalCategories(auth.token,placeId));
        dispatch(getTicketType(auth.token, placeId));
    },[auth.token,placeId]);
    
    
    const [additionalCategories, setCategories] = useState([]);
    const [additionalSubCategories, setSubCategories] = useState([]);
    const [additionalSubSubCategories, setSubSubCategories] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [additionalId, setAdditionalId] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    
    const handleTicketTypes = (e) => {
        const { name,value } = e.target;
        setTicketTypes((prev) => ({
            ...prev,
            [name] : value,
        }));
        if(name == 'ticket_type_id'){
            dispatch(getTicketSubType(auth.token, value));
        }
        if(name == 'ticket_sub_type_id'){
            dispatch(getTicketSubSubType(auth.token, value));
        }
    };

    const fetchAdditionalCategories = async () => {
        try {
          setLoading(true);
          const res = await axios.get(`/api/admin/v1/get-additional-categories/${placeId}/${addFormType}`, {
            headers: { Authorization: `Bearer ${auth.token}` },
          });
          setCategories(res.data.categories || []);
        } catch (err) {
          setError(err.response?.data?.message || "Error fetching categories");
        } finally {
          setLoading(false);
        }
      };
    
      const fetchAdditionalSubCategories = async () => {
        try {
          setLoading(true);
          const res = await axios.get(`/api/admin/v1/get-additional-subCategories/${placeId}/${addFields.booking_category_id}/${addFormType}`, {
            headers: { Authorization: `Bearer ${auth.token}` },
          });
          setSubCategories(res.data.subCategories || []);
        } catch (err) {
          setError(err.response?.data?.message || "Error fetching subcategories");
        } finally {
          setLoading(false);
        }
      };
    
      const fetchAdditionalSubSubCategories = async () => {
        try {
          setLoading(true);
          const res = await axios.get(`/api/admin/v1/get-additional-subSubCategories/${placeId}/${addFields.booking_category_id}/${addFields.booking_sub_category_id}/${addFormType}`, {
            headers: { Authorization: `Bearer ${auth.token}` },
          });
          setSubSubCategories(res.data.subSubCategories || []);
        } catch (err) {
          setError(err.response?.data?.message || "Error fetching sub-subcategories");
        } finally {
          setLoading(false);
        }
      };


      useEffect(() => {
        if (auth.token && placeId && addFormType) {
          fetchAdditionalCategories();
        }
      }, [auth.token, placeId, addFormType]);
    
      useEffect(() => {
        if (auth.token && placeId && addFields.booking_category_id && addFormType) {
          fetchAdditionalSubCategories();
        }
      }, [auth.token, placeId, addFields.booking_category_id, addFormType]);
    
      useEffect(() => {
        if (auth.token && placeId && addFields.booking_category_id && addFields.booking_sub_category_id && addFormType) {
          fetchAdditionalSubSubCategories();
        }
      }, [auth.token, placeId, addFields.booking_category_id, addFields.booking_sub_category_id, addFormType]);


        // Booking Category
        const [bookingCategory, setBookingCategory] = useState([{ name: '' }]);

        const addBookingCategoryInput = () => {
            setBookingCategory((prev) => [...prev, { name: "" }]);
        };
    
        const removeBookingCategoryInput = (index) => {
            if (bookingCategory.length > 1) {
                setBookingCategory((prev) => prev.filter((_, i) => i !== index));
            }
        };
    
        const handleBookingCategoryChange = (index, field, value, type) => {
            setBookingCategory((prev) => {
                const newFields = prev.map((item, i) =>
                    i === index ? { ...item, [field]: value } : item
                );
                const updatedItem = newFields[index];
                if (updatedItem.name != '') {
                    newFields[index] = { ...updatedItem,};
                }
                return newFields;
            });
        };

        useEffect(()=>{
            // console.log('bookingCategory>>',bookingCategory);
        },[bookingCategory])
    
        const handleBookingCategorySubmit = () => {
            if(!placeId){
                return toast.error('Please select the category');
            }
            const formData = new FormData();
            bookingCategory.forEach((item, index) => {
                if (item.name !== "" && item.field_type_id !== "") {
                    formData.append(`booking_category[${index}][category_id]`, 0);
                    formData.append(`booking_category[${index}][name]`, item.name);
                    formData.append(`booking_category[${index}][place_id]`, placeId);
                    formData.append(`booking_category[${index}][type]`, addFormType);
                }
            });
            axios.post(`/api/admin/v1/add-additional-category`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${auth?.token}`,
                },
            }).then((res) => {
                toast.success(res.data?.message);
                setCategories(res.data?.categories || []);
                setBookingCategory([{ name: '' }]);
                // dispatch({
                //     type: "GET_BOOKING_CATEGORIES_FULFILLED",
                //     payload: res?.data,
                // });
            }).catch((err) => {
                toast.error(err.response.data?.message || "An error occurred");
                setErrors(err.response.data);
            });
        };
    
        // Sub Booking Category
    
        const [subBookingCategory, setSubBookingCategory] = useState([{ field_type_id: '', additional_field_id: '', name: '' }]);
    
        const addSubBookingCategoryInput = () => {
            setSubBookingCategory((prev) => [...prev, { field_type_id: "", additional_field_id: "", name: "" }]);
        };
    
        const removeSubBookingCategoryInput = (index) => {
            if (subBookingCategory.length > 1) {
                setSubBookingCategory((prev) => prev.filter((_, i) => i !== index));
            }
        };
    
        const handleSubBookingCategoryChange = (index, field, value, type) => {
            setSubBookingCategory((prev) => {
                const newFields = prev.map((item, i) =>
                    i === index ? { ...item, [field]: value } : item
                );
                return newFields;
            });
        };
    
        const handleSubBookingCategorySubmit = () => {
            if(!placeId){
                return toast.error('Please select the category');
            }
            if(!ticketForm.booking_category_id){
                return toast.error('Please select the Booking category');
            }
            const formData = new FormData();
            subBookingCategory.forEach((item, index) => {
                if(!item.name){
                    return toast.error('Booking Subcategory name is required!');
                }
                formData.append(`booking_category[${index}][name]`, item.name);
                formData.append(`booking_category[${index}][place_id]`, placeId);
                formData.append(`booking_category[${index}][category_id]`, ticketForm.booking_category_id);
                formData.append(`booking_category[${index}][type]`, addFormType);
            });
            axios.post(`/api/admin/v1/add-additional-subCategory`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${auth?.token}`,
                },
            }).then((res) => {
                toast.success(res.data?.message);
                setSubCategories(res.data.subCategories || []);
                setSubBookingCategory([{ field_type_id: '', additional_field_id: '', name: '' }]);
                // dispatch({
                //     type: "GET_BOOKING_SUB_CATEGORIES_FULFILLED",
                //     payload: res?.data,
                // });
            }).catch((err) => {
                toast.error(err.response.data?.message || "An error occurred");
                setErrors(err.response.data);
            });
        };
    
        // Sub Sub Booking Category
        const [subSubBookingCategoryInput, setSubSubBookingCategoryInput] = useState([{ field_type_id: '', additional_field_id: '', sub_additional_field_id: '', name: '' }]);
    
        const addSubSubBookingCategory = () => {
            setSubSubBookingCategoryInput((prev) => [...prev, { field_type_id: '', additional_field_id: '', sub_additional_field_id: '', name: "" }]);
        };
    
        const removeSubSubBookingCategory = (index) => {
            if (subSubBookingCategoryInput.length > 1) {
                setSubSubBookingCategoryInput((prev) => prev.filter((_, i) => i !== index));
            }
        };
    
        const handleSubSubBookingCategoryChange = (index, field, value, type) => {
            setSubSubBookingCategoryInput((prev) => {
                const newFields = prev.map((item, i) =>
                    i === index ? { ...item, [field]: value } : item
                );
                return newFields;
            });
        };
    
        const handleSubSubBookingCategorySubmit = () => {
            if(!placeId){
                return toast.error('Category field is required!');
            }
            if(!ticketForm.booking_category_id){
                return toast.error('Booking category field is required!');
            }
            if(!ticketForm.booking_sub_category_id){
                return toast.error('Booking Sub category field is required!');
            }
            const formData = new FormData();
            subSubBookingCategoryInput.forEach((item, index) => {
                if(!item.name){
                    return toast.error('Booking Sub Sub category name is required!');
                }
                formData.append(`booking_category[${index}][category_id]`, ticketForm.booking_category_id);
                formData.append(`booking_category[${index}][sub_category_id]`, ticketForm.booking_sub_category_id);
                formData.append(`booking_category[${index}][name]`, item.name);
                formData.append(`booking_category[${index}][place_id]`,placeId);
                formData.append(`booking_category[${index}][type]`, addFormType);
            });
            axios.post(`/api/admin/v1/add-additional-subSubCategory`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${auth?.token}`,
                },
            }).then((res) => {
                toast.success(res.data?.message);
                setSubSubCategories(res.data.subSubCategories || []);
                setSubSubBookingCategoryInput([{ field_type_id: '', additional_field_id: '', sub_additional_field_id: '', name: '' }]);
                // dispatch({
                //     type: "GET_BOOKING_SUB_SUB_CATEGORIES_FULFILLED",
                //     payload: res?.data,
                // });
            }).catch((err) => {
                toast.error(err.response.data?.message || "An error occurred");
                setErrors(err.response.data);
            });
        };

    const convertToSnakeCase = (str) => {
        return str
            .toLowerCase()                // Convert to lowercase
            .replace(/\s+/g, "_")         // Replace spaces with underscores
            .replace(/[^a-z0-9_]/g, "");  // Remove special characters (if any)
    };

    const handleAddFieldChange = (e) => {
        const { name, value, type, files } = e.target;
        setAddFields((prev) => ({
            ...prev,
            [name]: type === "file" ? files[0] : value,
            name_attr: name === "field_name" ? convertToSnakeCase(value) : prev.name_attr,
        }));
        if (name === "booking_category_id") {
            dispatch(getAdditionalSubCategories(auth.token, placeId,addFormType));
        } else if (name === "booking_sub_category_id") {
            dispatch(getAdditionalSubSubCategories(auth.token, placeId,addFormType));
        }
    };

    const addAllAdditionalField = () => {
        const data = {
            ...addFields,
            ...ticketTypes,
        }
        axios.post(`/api/admin/v1/add-ticketform-additional-fields`, data, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message);
            setAddFields({
                booking_category_id: "",
                booking_sub_category_id: "",
                field_name: "",
                field_type: "",
                file: "",
                link: "",
                is_upload_doc: 0,
                add_field_for:addFormType,
                active_on_main_form: 1,
                place_id:placeId,
            });
            dispatch(getTicketInfoByPlaceId(auth?.token,placeId));
        }).catch((err) => {
            toast.error(err.response.data);
            setErrors(err.response.data);
        });
    };

    const updateAdditionalField = () => {
        axios.post(`/api/admin/v1/update-ticketform-additional-field/${additionalId}`, addFields, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message);
            setAddFields({
                booking_category_id: "",
                booking_sub_category_id: "",
                field_name: "",
                field_type: "",
                file: "",
                link: "",
                is_upload_doc: 0,
                add_field_for:addFormType,
                active_on_main_form: 1,
                place_id:placeId,
            });
            dispatch(getTicketInfoByPlaceId(auth?.token,placeId));
        }).catch((err) => {
            toast.error(err.response.data);
            setErrors(err.response.data);
        });
    };

    const getAdditionalEditdata = async (id) => {
        try {
            setLoading(true);
            setAdditionalId(id);
            const res = await axios.get(`/api/admin/v1/edit-ticketform-additional-fields/${id}`, {
                headers: { Authorization: `Bearer ${auth.token}` },
            });
            const data = res.data?.data;
            setIsEdit(true);
            setAddFields((prev) => ({
                ...prev,
                booking_category_id:data?.booking_category_id,
                booking_sub_category_id:data?.booking_sub_category_id,
                booking_sub_sub_category_id:data?.booking_sub_sub_category_id,
                field_name:data?.field_name,
                field_type:data?.field_type,
                link:data?.link,
                name_attr:data?.name_attr,
                add_field_for:addFormType,
                active_on_main_form:data?.active_on_main_form,
                is_upload_doc:data?.is_upload_doc,
                place_id:placeId,
            }));
            console.log(data?.booking_category_id,data);
        } catch (err) {
            setError(err.response?.data?.message || "Error fetching sub-subcategories");
        } finally {
            setLoading(false);
        }
    };

    const handleDel = (id) => {
        if (window.confirm("Are You Sure You Want To Delete !")) {
            axios.delete(`/api/admin/v1/delete-ticketform-additional-field/${id}`, {
                headers: {
                    Authorization: `Bearer ${auth?.token}`,
                },
            }).then((res) => {
                toast.success(res.data.message);
                dispatch(getTicketInfoByPlaceId(auth?.token,placeId));
            }).catch((err) => toast.error("Somthing Went Wrong"));
        }
    };
 
    useEffect(()=>{
        console.log('addFields>>', addFields);
        console.log('ticketFormAdditionalFields>>', ticketFormAdditionalFields);
    },[addFields,ticketFormAdditionalFields])

    return (
        // <div className="container bg-white p-4 rounded shadow-lg">

            <Row>
                <Col md={4} className="mt-3">
                    <div className="mb-3">
                        <Input type="select" name="ticket_type_id"
                            value={ticketTypes.ticket_type_id}
                            onChange={handleTicketTypes}
                        >
                            <option value="">Select Ticket Type</option>
                                {TicketTypeList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.ticket_type}
                                    </option>
                                ))}
                        </Input>
                        <span className="d-block text-danger">{errors?.ticket_type_id}</span>
                    </div>
                </Col>
                <Col md={4} className="mt-3">
                    <div className="mb-3">
                        <Input type="select" name="ticket_sub_type_id"
                            value={ticketTypes.ticket_sub_type_id}
                            onChange={handleTicketTypes}
                        >
                            <option value="">Select Ticket Sub Type</option>
                                {TicketSubTypeList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.sub_type}
                                    </option>
                                ))}
                        </Input>
                        <span className="d-block text-danger">{errors?.ticket_sub_type_id}</span>
                    </div> 
                </Col>
                <Col md={4} className="mt-3">
                    <div className="mb-3">
                        <Input type="select" name="ticket_sub_sub_type_id"
                            value={ticketTypes.ticket_sub_sub_type_id}
                            onChange={handleTicketTypes}
                        >
                            <option value="">Select Ticket Type</option>
                                {TicketSubSubTypeList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.sub_sub_type}
                                    </option>
                                ))}
                        </Input>
                        <span className="d-block text-danger">{errors?.ticket_sub_sub_type_id}</span>
                    </div> 
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="checkbox"
                                checked={ticketForm.is_group_booking_category === 1}
                                onChange={(e) => {
                                    setTicketForm(prev => ({
                                        ...prev,
                                        is_group_booking_category: e.target.checked ? 1 : 0
                                    }));
                                }}
                                className="me-2" />
                            Booking Category
                        </Label>
                    </FormGroup>
                    {ticketForm.is_group_booking_category === 1 && (
                        <>
                            {bookingCategory?.map((field, i) => (
                                <div className="d-flex align-items-center mb-3" key={i}>
                                    <Input type="text"
                                        placeholder="Field Name"
                                        value={field.name}
                                        onChange={(e) => handleBookingCategoryChange(i, "name", e.target.value, 'groupBooking')}
                                        className="me-2" />
                                    <Button className="ms-1" color="primary" onClick={addBookingCategoryInput}>
                                        +
                                    </Button>
                                    <Button className="ms-1" color="danger" onClick={() => removeBookingCategoryInput(i)}>
                                        -
                                    </Button>
                                </div>
                            ))}
                            <Button className="bg-success text-white" size="sm" onClick={handleBookingCategorySubmit}>
                                Add Booking Category
                            </Button>
                        </>
                    )}
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="checkbox"
                                checked={ticketForm.is_group_booking_sub_category === 1}
                                onChange={(e) => {
                                    setTicketForm(prev => ({
                                        ...prev,
                                        is_group_booking_sub_category: e.target.checked ? 1 : 0
                                    }));
                                }}
                                className="me-2" />
                            Booking Sub Category
                        </Label>
                    </FormGroup>
                    {ticketForm.is_group_booking_sub_category === 1 && ticketForm.is_group_booking_category === 1 && (
                        <>
                            <div className="mb-3">
                                <Input type="select" name="place_id"
                                    value={ticketForm.booking_category_id}
                                    onChange={(e) =>{
                                        setTicketForm((prev) => ({
                                            ...prev,
                                            booking_category_id: e.target.value,
                                        }))
                                        // dispatch(getBookingSubCategories(auth.token,placeId,e.target.value))
                                        dispatch(getAdditionalSubCategories(auth.token,placeId,addFormType))
                                    }}
                                >
                                    <option value="">Select Booking Category</option>
                                    {additionalCategories?.filter(item => item?.type == addFormType )?.map((item) => (
                                        <option key={item.id} value={item.id}>{item.name}</option>
                                    ))}
                                </Input>
                            </div>
                            {subBookingCategory?.map((field, i) => (
                                <div className="d-flex align-items-center mb-3" key={i}>
                                    <Input type="text"
                                        placeholder="Field Name"
                                        value={field.name}
                                        onChange={(e) => handleSubBookingCategoryChange(i, "name", e.target.value, 'groupBooking')}
                                        className="me-2" />
                                    <Button className="ms-1" color="primary" onClick={addSubBookingCategoryInput}>
                                        +
                                    </Button>
                                    <Button className="ms-1" color="danger" onClick={() => removeSubBookingCategoryInput(i)}>
                                        -
                                    </Button>
                                </div>
                            ))}
                            <Button className="bg-success text-white" size="sm" onClick={handleSubBookingCategorySubmit}>
                                Add Booking Sub Category
                            </Button>
                        </>
                    )}
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="checkbox"
                                checked={ticketForm.is_group_booking_sub_sub_category === 1}
                                onChange={(e) => {
                                    setTicketForm(prev => ({
                                        ...prev,
                                        is_group_booking_sub_sub_category: e.target.checked ? 1 : 0
                                    }));
                                }}
                                className="me-2" />
                            Booking Sub Sub Category
                        </Label>
                    </FormGroup>
                    {ticketForm.is_group_booking_sub_sub_category === 1 && ticketForm.is_group_booking_sub_category === 1 && ticketForm.is_group_booking_category === 1 && (
                        <>
                            <div className="mb-3">
                                <Input type="select" name="place_id"
                                    value={ticketForm.booking_sub_category_id}
                                    onChange={(e) =>{
                                        setTicketForm((prev) => ({
                                            ...prev,
                                            booking_sub_category_id: e.target.value,
                                        }));
                                        // dispatch(getBookingSubSubCategories(auth.token,placeId,ticketForm.booking_category_id,e.target.value))
                                        dispatch(getAdditionalSubSubCategories(auth.token,placeId,addFormType))
                                    }}
                                >
                                    <option value="">Select Booking Sub Category</option>
                                    {additionalSubCategories?.filter(item => item?.type == addFormType )?.map((item) => (
                                        <option key={item.id} value={item.id}>{item.name}</option>
                                    ))}
                                </Input>
                            </div> 
                            {subSubBookingCategoryInput?.map((field, i) => (
                                <div className="d-flex align-items-center mb-3" key={i}>
                                    <Input type="text"
                                        placeholder="Field Name"
                                        value={field.name}
                                        onChange={(e) => handleSubSubBookingCategoryChange(i, "name", e.target.value, 'groupBooking')}
                                        className="me-2" />
                                    <Button className="ms-1" color="primary" onClick={addSubSubBookingCategory}>
                                        +
                                    </Button>
                                    <Button className="ms-1" color="danger" onClick={() => removeSubSubBookingCategory(i)}>
                                        -
                                    </Button>
                                </div>
                            ))}
                            <Button className="bg-success text-white" size="sm" onClick={handleSubSubBookingCategorySubmit}>
                                Add Booking Sub Sub Category
                            </Button>
                        </>
                    )}
                </Col>
                <Col md={12} className="mt-3">
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                        <h4 className="text-right text-black me-2">  Additional Fields</h4>
                        <div className="form-check form-switch">
                            <Input type="checkbox"
                                checked={ticketForm.is_additional_fields === 1}
                                onChange={(e) => {
                                    setTicketForm(prev => ({
                                        ...prev,
                                        is_additional_fields: e.target.checked ? 1 : 0
                                    }));
                                }}
                                className="me-2" />
                        </div>
                        </Label>
                    </FormGroup>
                </Col>
                <Col md={12} className="mt-3">
                    {(ticketForm.is_additional_fields === 1 && addFormType !="") && (
                        <>
                        <Row>
                            <>
                            <Col md={4} className="mt-3">
                                <div className="mb-3">
                                    <Input type="select" name="booking_category_id"
                                        value={addFields.booking_category_id}
                                        onChange={(e) => {
                                            handleAddFieldChange(e);
                                            setAddFields((prev) => ({
                                                ...prev,
                                                active_on_main_form: 0,
                                            }));
                                        }}
                                    >
                                        <option value="">Select Booking Category</option>
                                        {additionalCategories?.filter(item => item?.type == addFormType )?.map((item) => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))}
                                    </Input>
                                    <span className="d-block text-danger">{errors?.booking_category_id}</span>
                                </div>
                            </Col>
                            <Col md={4} className="mt-3">
                                <div className="mb-3">
                                    <Input type="select" name="booking_sub_category_id"
                                        value={addFields.booking_sub_category_id}
                                        onChange={(e) => {
                                            handleAddFieldChange(e);
                                            setAddFields((prev) => ({
                                                ...prev,
                                                active_on_main_form: 0,
                                            }));
                                        }}
                                    >
                                        <option value="">Select Booking Sub Category</option>
                                        {additionalSubCategories?.filter(item => item?.type == addFormType )?.map((item) => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))}
                                    </Input>
                                    <span className="d-block text-danger">{errors?.booking_sub_category_id}</span>
                                </div> 
                            </Col>
                            <Col md={4} className="mt-3">
                                <div className="mb-3">
                                    <Input type="select" name="booking_sub_sub_category_id"
                                        value={addFields.booking_sub_sub_category_id}
                                        onChange={(e) => {
                                            handleAddFieldChange(e);
                                            setAddFields((prev) => ({
                                                ...prev,
                                                active_on_main_form: 0,
                                            }));
                                        }}
                                    >
                                        <option value="">Select Booking Sub Sub Category</option>
                                        {additionalSubSubCategories?.filter(item => item?.type == addFormType )?.map((item) => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))}
                                    </Input>
                                    <span className="d-block text-danger">{errors?.booking_sub_sub_category_id}</span>
                                </div> 
                            </Col>
                            </>
                            <Col md={3} className="mt-3">
                                <Input type="text"
                                    placeholder="Field Name"
                                    name="field_name"
                                    value={addFields.field_name}
                                    onChange={handleAddFieldChange}
                                    className="me-2" />
                                <span className="d-block text-danger">{errors?.field_name}</span>
                                <span className="d-block text-danger">{errors?.place_id}</span>
                            </Col>
                            <Col md={3} className="mt-3">
                                <Input type="select" name="field_type"
                                    value={addFields.field_type}
                                    onChange={handleAddFieldChange}
                                >
                                    <option  value="">Select Field Type</option>
                                    <option  value="text">Text Field</option>
                                    <option  value="textarea">Textarea Field</option>
                                    {/* <option  value="dropdown">Dropdown Field</option> */}
                                    {/* <option  value="radio">Radio Field</option> */}
                                    <option  value="checkbox">Checkbox Field</option>
                                    <option  value="document">Attach Document</option>
                                </Input>
                                <span className="d-block text-danger">{errors?.field_type}</span>
                            </Col>
                            {/* {addFields.field_type === "document" && ( */}
                                <>
                                    <Col md={3} className="mt-3">
                                        <Input type="file"
                                            name="file"
                                            onChange={handleAddFieldChange}
                                            className="me-2" />
                                    </Col>
                                    <Col md={3} className="mt-3">
                                        <Input type="text"
                                        placeholder="Link"
                                        name="link"
                                        value={addFields.link}
                                        onChange={handleAddFieldChange}
                                        className="me-2" />
                                    </Col>
                                    <Col md={3} className="mt-3">
                                        <FormGroup>
                                            <Label className="d-flex align-items-center">
                                                <Input type="checkbox"
                                                    checked={addFields.is_upload_doc == 1}
                                                    onChange={(e) => {
                                                        setAddFields(prev => ({
                                                            ...prev,
                                                            is_upload_doc: e.target.checked ? 1 : 0
                                                        }));
                                                    }}
                                                    className="me-2" />
                                                Enable Upload (By user)
                                            </Label>
                                        </FormGroup>
                                    </Col>
                                </>
                             {/* )} */}
                            <Col md={4} className="mt-3">
                                {isEdit == false ? (
                                    <Button className="ms-1" disabled={(placeId != 0) ? false:true} color="primary" 
                                        onClick={addAllAdditionalField}
                                    >
                                        Add Additional Fields
                                    </Button>
                                ):(
                                    <Button className="ms-1" disabled={(placeId != 0) ? false:true} color="primary" 
                                        onClick={updateAdditionalField}
                                    >
                                        Update Additional Fields
                                    </Button>
                                )}
                            </Col>
                            
                        </Row>
                        </>
                    )}
                </Col>
                <Col md={12} className="mt-3">
                    {ticketFormAdditionalFields.length > 0 && (
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Booking Category</th>
                                    <th>Booking Sub Category</th>
                                    <th>Booking Sub Sub Category</th>
                                    <th>Column For</th>
                                    <th>Field Name</th>
                                    <th>Field Type</th>
                                    <th>File</th>
                                    <th>Link</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ticketFormAdditionalFields.filter(item => item.add_field_for == addFormType).map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?.additionalCategory?.name ?? 'N/A'}</td>
                                        <td>{item?.additionalSubCategory?.name ?? 'N/A'}</td>
                                        <td>{item?.additionalSubSubCategory?.name ?? 'N/A'}</td>
                                        <td>{(item?.active_on_main_form == 1) ? 'Main Form Field':'N/A'}</td>
                                        <td>{item.field_name}</td>
                                        <td>{item.field_type}</td>
                                        <td>{item.file ? item.file.name : "N/A"}</td>
                                        <td>{item.link ?? "N/A"}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                            <AiOutlineEdit
                                            size={22}
                                            className="text-warning me-3"
                                            onClick={() => {
                                                setTicketForm(prev => ({
                                                    ...prev,
                                                    is_additional_fields: 1
                                                }));
                                                getAdditionalEditdata(item.id);
                                            }}
                                            />
                                            <AiOutlineDelete
                                                size={22}
                                                className="text-danger"
                                                onClick={() => handleDel(item.id)}
                                            />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </Col>
            </Row>
        // </div>
    );
};

export default GroupBooking;
